/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILand {
  /** Площадь участка **/
  area?: TLand_Area;
  /** Единица измерения **/
  areaUnitType?: TLand_AreaUnitType;
  /** Возможно изменить cтатус **/
  possibleToChangeStatus?: TLand_PossibleToChangeStatus;
  /** Статус **/
  status?: TLand_Status;
  /** Тип участка **/
  type?: TLand_Type;
}

export type TLand_Area = null | TLand_Area_1;

export type TLand_Area_1 = string | number;

export type TLand_AreaUnitType = null | EAreaUnitType;

export enum EAreaUnitType {
  /** Гектар **/
  Hectare = 'hectare',
  /** Сотка **/
  Sotka = 'sotka',
}
export type TLand_PossibleToChangeStatus = null | boolean;

export type TLand_Status = null | EStatus;

export enum EStatus {
  /** Фермерское хозяйство **/
  Farm = 'farm',
  /** Участок сельскохозяйственного назначения **/
  ForAgriculturalPurposes = 'forAgriculturalPurposes',
  /** Участок лесного фонда **/
  ForestArea = 'forestArea',
  /** Садоводство **/
  Gardening = 'gardening',
  /** Садовое некоммерческое товарищество **/
  GardeningNonProfitPartnership = 'gardeningNonProfitPartnership',
  /** Индивидуальное жилищное строительство **/
  IndividualHousingConstruction = 'individualHousingConstruction',
  /** Земля промышленного назначения **/
  IndustrialLand = 'industrialLand',
  /** Участок промышленности, транспорта, связи и иного не сельхоз. назначения **/
  IndustryTransportCommunications = 'industryTransportCommunications',
  /** Инвестпроект **/
  InvestmentProject = 'investmentProject',
  /** Особо охраняемых категорий **/
  OfProtectedCategories = 'ofProtectedCategories',
  /** Личное подсобное хозяйство **/
  PrivateFarm = 'privateFarm',
  /** Участок запаса **/
  Reserve = 'reserve',
  /** Участок поселений **/
  Settlements = 'settlements',
  /** Дачное некоммерческое партнерство **/
  SuburbanNonProfitPartnership = 'suburbanNonProfitPartnership',
  /** Дачное некоммерческое партнерство поселений **/
  SuburbanNonProfitSettlementsPartnership = 'suburbanNonProfitSettlementsPartnership',
  /** Участок водного фонда **/
  WaterArea = 'waterArea',
}
export type TLand_Type = null | EType;

export enum EType {
  /** В собственности **/
  Owned = 'owned',
  /** В аренде **/
  Rent = 'rent',
}
